import React, { useState } from 'react';
import { Link, graphql } from 'gatsby';
import {
  ShopLayout,
} from '../components/Layout';
import {
  RelatedProducts,
  ProductDetails,
  ImageGallery,
} from '../components/shop';
import {
  Wrapper,
  Shape,
  HtmlContent,
} from '../components/common';
import {
  useMousePosition,
  useDimensions,
  useScrollPosition,
} from '../util/hooks';
import { shapeColours } from '../util/brand';
import { isClient } from '../util/helpers';
import './product.scss';

const Product = (props) => {
  const {
    data: {
      site: {
        siteMetadata,
      },
      productData,
      product,
    },
    location,
  } = props;
  const {
    shopSlug,
  } = siteMetadata;
  const {
    title,
    description,
    images,
  } = product;
  const {
    x: cursorX,
    y: cursorY,
  } = useMousePosition();
  const {
    viewportWidth,
    viewportHeight,
    documentHeight,
  } = useDimensions();
  const viewportTopPos = useScrollPosition();
  const additionalInformation = productData && productData.data && productData.data.additionalInformation ? productData.data.additionalInformation : null;
  const seoData = {
    metaTitle: `${title} | See Make Play Shop`,
    metaDescription: description,
  };
  const [highlightColourIndex] = useState(Math.floor(Math.random() * shapeColours.length));
  const highlightColourHex = shapeColours[highlightColourIndex];
  if (isClient) {
    document.documentElement.style.setProperty('--highlight-colour', highlightColourHex);
    document.documentElement.style.setProperty('--bg-colour', '#FFFFF4');
  }
  return (
    <ShopLayout
      location={location}
      seoData={seoData}
      cursorX={cursorX}
      cursorY={cursorY}
      viewportWidth={viewportWidth}
      viewportHeight={viewportHeight}
      documentHeight={documentHeight}
      viewportTopPos={viewportTopPos}
    >
      <div className="shop-product">
        <div className="framing-shapes">
          <Shape
            shapeName="muncher"
            shapeColour="#EEEA00"
          />
          <Shape
            shapeName="pebbles"
            shapeColour="#F68E00"
          />
          <Shape
            shapeName="rainbow"
            shapeColour="#00BC74"
          />
          <Shape
            shapeName="moon"
            shapeColour="#FF6AB8"
          />
        </div>
        <Wrapper isBound>
          <Link
            to={`/${shopSlug}/`}
            className="back-to-shop-link styled-link"
            aria-label="Return to the shop home page"
          >
            <span>Back to all products</span>
          </Link>
          <div className="product-main">
            <div className="cols">
              <div className="col col-left">
                <ImageGallery
                  images={images}
                  highlightColourHex={highlightColourHex}
                />
              </div>
              <div className="col col-right">
                <ProductDetails
                  product={product}
                  highlightColourHex={highlightColourHex}
                />
              </div>
            </div>
            {additionalInformation && (
              <section className="additional-information">
                <h2>Whats included</h2>
                <div className="details-cols">
                  { additionalInformation.map((productDetail) => {
                    const {
                      additionalInformationBody,
                    } = productDetail;
                    return (
                      <div className="details-col">
                        <HtmlContent
                          className="additional-information-body"
                          content={additionalInformationBody.html}
                        />
                      </div>
                    );
                  })}
                </div>
              </section>
            )}
          </div>
        </Wrapper>
      </div>
      <RelatedProducts
        siteMetadata={siteMetadata}
      />
    </ShopLayout>
  );
};

export default Product;

export const productQuery = graphql`
  query ProductByHandle($handle: String!) {
    site {
      siteMetadata {
        shopSlug,
        shopCategorySlug,
      }
    },
    # productData: prismicProduct(data: { product: { handle: { eq: $handle } } }) {
    #   data {
    #     additionalInformation: additional_information {
    #       additionalInformationBody: additional_information_body {
    #         html
    #       }
    #     }
    #   }
    # }
    product: shopifyProduct(handle: { eq: $handle }) {
      id
      title
      handle
      productType
      description
      descriptionHtml
      shopifyId
      options {
        id
        name
        values
      }
      variants {
        id
        title
        price
        availableForSale
        shopifyId
        selectedOptions {
          name
          value
        }
      }
      images {
        originalSrc
        id
        localFile {
          childImageSharp {
            fluid(maxWidth: 1400) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;
